import { Refresh } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";

// The React Query cache is persisted to localStorage, so an F5 inside the staleTime window fires no
// request and keeps showing the old numbers — this button forces the fetch.
// Refetch instead of invalidate: the dashboards page mounts only the selected tab, so refetching the
// ACTIVE queries hits exactly the dashboard on screen and leaves the other tabs' cache untouched
// (invalidating would mark them stale and make the next tab switch pay for requests it doesn't need).
export const DashboardRefreshButton = () => {
    const queryClient = useQueryClient();
    const isRefreshing = useIsFetching() > 0;
    const refreshVisibleDashboard = () => {
        queryClient.refetchQueries({ type: "active" });
    };

    return (
        <Button
            variant="outlined"
            size="small"
            startIcon={<Refresh />}
            onClick={refreshVisibleDashboard}
            disabled={isRefreshing}
            sx={{ mt: 0.5 }}
        >
            {isRefreshing ? "A atualizar…" : "Atualizar"}
        </Button>
    );
};
